import { useEffect, useState } from 'react';
import { Alert, Container, Row, Col } from "react-bootstrap"
import { useNavigate } from "react-router";
import { useParams } from "react-router-dom";
import { CustomButton } from './StyledComponents';
import LocalizedStrings from 'react-localization';

import { useQuery } from './../Utils';
import { JobService, JobList, ApplicationService, StatisticService } from '../Api';
import { LoadingStates, ErrorViewType } from './Enums'
import { ApplicationData } from './form/ApplicationData';

let locStrings = new LocalizedStrings({
    de:
    {
        displayJobList: "Stellenliste anzeigen",
        submitApplicationErrorLabelSupportUrl: "Support-Seite",
        submitApplicationErrorLabelSupportEmail: "Support-E-Mail-Adresse",
        submitApplicationErrorLabelSupportPhoneNumber: "Support-Telefonnummer",
        back: "Zurück zum Bewerbungsformular",
        retry: "Bewerbung erneut senden",
    },
    en:
    {
        displayJobList: "Display job list",
        submitApplicationErrorLabelSupportUrl: "Support page",
        submitApplicationErrorLabelSupportEmail: "Support email address",
        submitApplicationErrorLabelSupportPhoneNumber: "Support phone number",
        back: "Back to the application form",
        retry: "Retry sending application",
    }
});

interface ErrorViewProps{
    message: string
    description?: string
    errorViewType?: ErrorViewType
    useCustomSubmitApplicationTexts?: boolean
    setUploadStatus?: any
    showRetry?: boolean
    valuesApplicationDataForm?: ApplicationData,
}

export const ErrorView = (props: ErrorViewProps) => {
    const { tenant, listName } = useParams();
    const [jobList, setJobList] = useState<JobList>()
    const descriptionHTML = { __html: props.description ?? ''};  // Allows "<br/>"
    const useCustomSubmitApplicationTexts = props.useCustomSubmitApplicationTexts ?? false;
    const supportUrl = jobList?.supportUrl ?? '';
    const supportEmail = jobList?.supportEmail ?? '';
    const supportEmailLink = supportEmail ? ("mailto:" + supportEmail) : '';
    const supportPhoneNumber = jobList?.supportPhoneNumber ?? '';
    const supportCustomMessage = { __html: jobList?.supportCustomMessage ?? ''};  // Allows "<br/>"
    const query = useQuery();
    const previewMode = query.get("preview") !== null && query.get("preview") === "true";

    let navigate = useNavigate();

    const onJobListClick = () => {
        navigate(`/${tenant}/${listName}`, {});
    }

    const onBackClick = () => {
        props.setUploadStatus(LoadingStates.Restore);
    }

    // const onRetry = () => {
    //     if (previewMode === true) return;

    //     if (props.valuesApplicationDataForm && jobList){

    //         const listId = jobList.id;

    //         // ckeck H.o.n.e.y.p.o.t
    //         if (props.valuesApplicationDataForm.name.length > 0 || props.valuesApplicationDataForm.email.length > 0) return;

    //         if (!jobList) return;
    //         let application = props.valuesApplicationDataForm.getApplication(jobList?.jobs[0].tenant, jobList?.jobs[0].id,listId)

    //         const data = new FormData()
    //         data.append('application', JSON.stringify(application))
    //         if (props.valuesApplicationDataForm.cvFile) data.append('cv', props.valuesApplicationDataForm.cvFile, props.valuesApplicationDataForm.cvFile.name)

    //         data.append('additionalFilesCount', props.valuesApplicationDataForm.additionalFiles == null ? '0' : props.valuesApplicationDataForm.additionalFiles.length.toString())
    //         if (props.valuesApplicationDataForm.additionalFiles) {
    //             for (let i = 0; i < props.valuesApplicationDataForm.additionalFiles.length; i++) {
    //                 const element = props.valuesApplicationDataForm.additionalFiles[i];
    //                 data.append('file' + i, element, element.name)
    //             }
    //         }

    //         props.setUploadStatus(LoadingStates.Pending);
    //         ApplicationService.postApplication(data).then(result => {
    //             if (result) {
    //                 props.setUploadStatus(LoadingStates.Success);
    //                 StatisticService.updateCounter(jobList?.jobs[0].tenant, jobList?.jobs[0].id, "FormApplicationCount").then(result => {
    //                     console.log("");
    //                 }).catch(() => {
    //                     console.log("");
    //                 });
    //             }
    //             else {
    //                 props.setUploadStatus(LoadingStates.Fail);
    //             }
    //         }).catch(() => {
    //             props.setUploadStatus(LoadingStates.Fail);
    //         });
    //     }
    // }

    useEffect(() => {
        if (tenant && listName) {
            JobService.getJobs(tenant, listName, true).then(result => {
                if (result) {
                    setJobList(result)
                }
            })
        }
    }, [listName, tenant])

    return (
        <>
            {props.errorViewType === ErrorViewType.JobViewErrorView &&
                <Container style={{ backgroundColor: "white" }}>
                    <Row>
                        <Col lg={12}>
                            <div style={{ paddingTop: "30px", paddingLeft: "6px", display: "flex", justifyContent: "left" }}>
                                {jobList &&
                                    <CustomButton onClick={onJobListClick} colors={jobList.colors}>{locStrings.displayJobList}</CustomButton>
                                }
                            </div>
                        </Col>
                    </Row>
                </Container>
            }
            {props.errorViewType === ErrorViewType.FormViewErrorView &&
                <Container style={{ backgroundColor: "white" }}>
                    <Row>
                        <Col lg={12}>
                            <div style={{ paddingTop: "30px", paddingLeft: "6px", display: "flex", justifyContent: "left" }}>
                                {jobList &&
                                    <CustomButton onClick={onBackClick} colors={jobList.colors}>{locStrings.back}</CustomButton>
                                }
                            </div>
                        </Col>
                    </Row>
                </Container>
            }
            <Alert variant="danger" style={{ margin: "30px" }}>
                <Alert.Heading>{props.message}</Alert.Heading>
                {!useCustomSubmitApplicationTexts && <p>
                    {props.description && <p>
                        <div dangerouslySetInnerHTML={descriptionHTML}></div>
                    </p>}
                </p>}
                {useCustomSubmitApplicationTexts && <p>
                    {supportCustomMessage && <p>
                        <div dangerouslySetInnerHTML={supportCustomMessage}></div>
                    </p>}
                    {!supportCustomMessage && props.description && <p>
                        <div dangerouslySetInnerHTML={descriptionHTML}></div>
                    </p>}
                    {supportUrl && <p>
                        {locStrings.submitApplicationErrorLabelSupportUrl}<br/>
                        {<a href={supportUrl} target="_blank" rel="noreferrer" >{supportUrl}</a>}
                    </p>}
                    {supportEmail && <p>
                        {locStrings.submitApplicationErrorLabelSupportEmail}<br/>
                        {<a href={supportEmailLink} target="_blank" rel="noreferrer" >{supportEmail}</a>}
                    </p>}
                    {supportPhoneNumber && <p>
                        {locStrings.submitApplicationErrorLabelSupportPhoneNumber}<br/>
                        {supportPhoneNumber}
                    </p>}
                </p>}
             </Alert>
            {/* {props.showRetry &&
                <Container style={{ backgroundColor: "white" }}>
                    <Row>
                        <Col lg={12}>
                            <div style={{ paddingTop: "30px", display: "flex", justifyContent: "center" }}>
                                {jobList &&
                                    <CustomButton onClick={onRetry} colors={jobList.colors}>{locStrings.retry}</CustomButton>
                                }
                            </div>
                        </Col>
                    </Row>
                </Container>
            } */}
        </>
    )
}